import { Link } from "react-router-dom";
import { mediaUrl } from "@/lib/api";
import { useCurrency } from "@/context/CurrencyContext";

export const ProductCard = ({ product, index = 0 }) => {
  const { format } = useCurrency();
  const soldOut = !!product.sold;
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block reveal"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="relative overflow-hidden bg-neutral-900 aspect-[3/4]">
        <img
          src={mediaUrl(product.images?.[0])}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105"
        />
        {soldOut && (
          <span className="absolute top-4 left-4 bg-black/80 text-white text-[10px] font-mono-label uppercase tracking-luxe px-3 py-1">
            Sold Out
          </span>
        )}
        {product.featured && !soldOut && (
          <span className="absolute top-4 left-4 bg-white text-black text-[10px] font-mono-label uppercase tracking-luxe px-3 py-1">
            New Drop
          </span>
        )}
      </div>
      <div className="pt-4 flex items-start justify-between gap-4">
        <div>
          <p className="font-mono-label text-[10px] uppercase tracking-luxe text-white/40 mb-1">{product.category}</p>
          <h3 className="text-white text-sm sm:text-base group-hover:opacity-60 transition-opacity">{product.name}</h3>
        </div>
        <span className="font-mono-label text-sm text-white/80 shrink-0">{format(product.price)}</span>
      </div>
    </Link>
  );
};
